import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Tabs } from 'antd';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import Others from 'component/create_user_component/create_singleUser/others';
import TabPane from 'antd/es/tabs/TabPane';
import Organization from 'component/create_user_component/create_singleUser/organization';
import Address from 'component/create_user_component/create_singleUser/address';
import {
  FormHeader,
  FormItem,
  FormSubmitButtonConatainer,
  ModalFormContainer,
  RowWrapper,
} from 'component/form_component/style';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { editUserData, getSingleUser } from 'redux/slices/userSlice';
import { UserStatusBottomWrap, UserStatusContent, UserStatusContentWrap, UserStatusWrap } from '../viewUser/style';

export default function UserPageEditUser({ dn, userPageData, handleCancel }) {
  const dispatch = useDispatch();
  const [formTab1] = Form.useForm();
  const [formTab2] = Form.useForm();
  const [formTab3] = Form.useForm();
  const [formTab4] = Form.useForm();
  const [activeTab, setActiveTab] = useState('1');
  const [loading, setLoading] = useState(false);
  const selectedNode = useSelector((state) => state.selectedNode);

  useEffect(() => {
    formTab1.setFieldsValue({
      fqdn: selectedNode.domainName,
    });
  }, [selectedNode, formTab1]);

  const onFinish = async () => {
    const Account = formTab1.getFieldsValue();
    const Address = formTab2.getFieldsValue();
    const Organization = formTab3.getFieldsValue();
    const others = formTab4.getFieldsValue();
    Account.fqdn = selectedNode.domainName;
    const values = {
      dn,
      updateUser: [
        {
          ...Account,
          street: Address.street ? Address.street : '',
          poBox: Address.poBox ? Address.poBox : '',
          zip: Address.zip ? Address.zip : '',
          city: Address.city ? Address.city : '',
          state: Address.state ? Address.state : '',
          country: Address.country ? Address.country : '',
          jobTitle: Organization.jobTitle ? Organization.jobTitle : '',
          company: Organization.company ? Organization.company : '',
          department: Organization.department ? Organization.department : '',
          description: others.description ? others.description : '',
          telephoneNumber: others.telephoneNumber ? others.telephoneNumber : '',
          office: others.office ? others.office : '',
          webPage: others.webPage ? others.webPage : '',
          ou: userPageData.ouDn ? userPageData.ouDn : null,
          passwordAtNextLogon: userPageData?.passwordAtNextLogon,
          userCannotChangePassword: userPageData?.userCannotChangePassword,
          passwordNeverExpires: userPageData?.passwordNeverExpires,
          isEnabled: userPageData?.isEnabled,
        },
      ],
      addGroupNames: [],
      removeGroupNames: [],
      customAttributes: [],
    };
    try {
      setLoading(true);
      const sweetAlert = await dispatch(editUserData(values));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
      handleCancel();
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    }
    await dispatch(
      getSingleUser({ userName: dn, fqdn: selectedNode.domainName, domainId: selectedNode.currentdomainId })
    );
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <ModalFormContainer style={{ marginBottom: 0 }} className='af-modal-container af-updateuser-single-modal-container'>
      {loading && <ModalOpenLoader />}
      <UserStatusWrap className='af-updateuser-single-status-section-wrap'>
        <div className='af-updateuser-single-status-dummy'></div>
        <UserStatusContentWrap className='af-updateuser-single-status-content-wrap'>
          <UserStatusContent className='af-updateuser-single-status-content'>
            <h4 className='af-updateuser-single-status-header'>Status:</h4>
            <span className='af-updateuser-single-status' style={{ display: 'flex' }}>
              <p
                className='af-updateuser-single-status-lock'
                style={{ color: userPageData.isLock ? 'darkred' : 'darkgreen' }}
              >
                {userPageData.isLock ? 'Locked' : 'Unlocked'}
              </p>
              &nbsp;<p className='af-updateuser-single-status-slash'>/</p>&nbsp;
              <p
                className='af-updateuser-single-status-disable'
                style={{ color: userPageData.isEnabled ? 'darkgreen' : 'darkred' }}
              >
                {userPageData.isEnabled ? 'Enabled' : 'Disabled'}
              </p>
            </span>
          </UserStatusContent>
          {/* <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <h4>Last Logon:</h4>
            <span>{userPageData.lastLogon}</span>
          </div> */}
        </UserStatusContentWrap>
      </UserStatusWrap>
      <FormHeader className='af-form-header af-updateuser-single-form-header'>
        {userPageData.displayName ? userPageData.displayName : userPageData.samAccountName}
      </FormHeader>
      <Form
        className='af-form af-updateuser-single-form'
        form={formTab1}
        layout='vertical'
        name='register'
        onFinish={onFinish}
        initialValues={{
          displayName: userPageData.displayName,
          emailAddress: userPageData.email,
          givenName: userPageData.givenName,
          surname: userPageData.surname,
          initials: userPageData.initials,
          fqdn: selectedNode.domainName,
          userPrincipalName: userPageData.userPrincipalName,
          samAccountName: userPageData.samAccountName,
        }}
        size='large'
      >
        <Tabs
          className='af-form-tab af-updateuser-single-form-tab'
          activeKey={activeTab}
          defaultActiveKey='1'
          onChange={handleTabChange}
          tabPosition='top'
          tabBarGutter={20}
        >
          <TabPane
            className='af-form-tab-tabpane af-updateuser-single-form-tab-tabpane af-updateuser-single-form-tab-tabpane_account'
            tab='Account'
            key='1'
            forceRender
          >
            <RowWrapper className='af-form-row-wraper af-updateuser-single-form-row-wraper af-updateuser-single-form-row-wraper-wrap1'>
              <FormItem
                className='af-form-item af-updateuser-single-form-item af-updateuser-single-form-item-givenname'
                key='givenName'
                name='givenName'
                label='First Name'
                style={{ flex: '40%' }}
              >
                <Input className='af-form-input af-updateuser-single-form-input af-updateuser-single-form-input_givenname' />
              </FormItem>
              <FormItem
                className='af-form-item af-updateuser-single-form-item af-updateuser-single-form-item-initials'
                key='initials'
                name='initials'
                label='Initial'
                style={{ flex: '15%' }}
              >
                <Input className='af-form-input af-updateuser-single-form-input af-updateuser-single-form-input_initials' />
              </FormItem>
              <FormItem
                className='af-form-item af-updateuser-single-form-item af-updateuser-single-form-item-surname'
                key='surname'
                name='surname'
                label='Last Name'
                style={{ flex: '40%' }}
              >
                <Input className='af-form-input af-updateuser-single-form-input af-updateuser-single-form-input_surname' />
              </FormItem>
            </RowWrapper>
            <RowWrapper className='af-form-row-wraper af-updateuser-single-form-row-wraper af-updateuser-single-form-row-wraper-wrap2'>
              <FormItem
                className='af-form-item af-updateuser-single-form-item af-updateuser-single-form-item-displayName'
                key='displayName'
                name='displayName'
                label='Display Name'
              >
                <Input className='af-form-input af-updateuser-single-form-input af-updateuser-single-form-input_displayName' />
              </FormItem>

              <FormItem
                key='emailAddress'
                name='emailAddress'
                label='E-mail'
                className='af-form-item af-updateuser-single-form-item af-updateuser-single-form-item-emailAddress'
              >
                <Input className='af-form-input af-updateuser-single-form-input af-updateuser-single-form-input_emailAddress' />
              </FormItem>
            </RowWrapper>
            <RowWrapper className='af-form-row-wraper af-updateuser-single-form-row-wraper af-updateuser-single-form-row-wraper-wrap3'>
              <FormItem
                key='userPrincipalName'
                name='userPrincipalName'
                label='User Principal Name (UPN)'
                className='disabled-row af-form-item af-updateuser-single-form-item af-updateuser-single-form-item-upn'
              >
                <Input className='af-form-input af-updateuser-single-form-input af-updateuser-single-form-input_upn' />
              </FormItem>
              <FormItem
                className='disabled-row af-form-item af-updateuser-single-form-item af-updateuser-single-form-item-samName'
                key='samAccountName'
                name='samAccountName'
                label='SAM Account Name'
              >
                <Input className='af-form-input af-updateuser-single-form-input af-updateuser-single-form-input_samName' />
              </FormItem>
            </RowWrapper>
          </TabPane>
          <TabPane
            tab='Address'
            key='2'
            forceRender
            className='af-form-tab-tabpane af-updateuser-single-form-tab-tabpane af-updateuser-single-form-tab-tabpane_address'
          >
            <Address formTab2={formTab2} singleUserData={userPageData} className='af-updateuser-single-form-address' />
          </TabPane>
          <TabPane
            tab='Organization'
            key='3'
            forceRender
            className='af-form-tab-tabpane af-updateuser-single-form-tab-tabpane af-updateuser-single-form-tab-tabpane_organization'
          >
            <Organization
              className='af-updateuser-single-form-organization'
              formTab3={formTab3}
              singleUserData={userPageData}
            />
          </TabPane>
          <TabPane
            tab='Others'
            key='4'
            forceRender
            className=' af-form-tab-tabpane af-updateuser-single-form-tab-tabpane af-updateuser-single-form-tab-tabpane_others'
          >
            <Others formTab4={formTab4} singleUserData={userPageData} className='af-updateuser-single-form-others' />
          </TabPane>
        </Tabs>

        <FormSubmitButtonConatainer className='af-form-button-submit-wrapper af-updateuser-single-form-button-submit-wrapper'>
          <StyledButton
            className='af-form-button af-updateuser-single-form-button_submit af-updateuser-single-form-button af-updateuser-single-form-button_submit'
            type='primary'
            htmlType='submit'
          >
            Submit
          </StyledButton>
        </FormSubmitButtonConatainer>
        <UserStatusBottomWrap className='af-updateuser-single-status-bottom-wrap'>
          <UserStatusContent className='af-updateuser-single-status-created-wrap'>
            <h4 className='af-updateuser-single-status-status-created-head'>Created:</h4>
            <span className='af-updateuser-single-status-status-created'>{userPageData.createdAt}</span>
          </UserStatusContent>
          <UserStatusContent className='af-updateuser-single-status-status-lastChange-wrap'>
            <h4 className='af-updateuser-single-status-status-lastChange-head'>Last Changed:</h4>
            <span className='af-updateuser-single-status-status-lastChange'>{userPageData.lastChanges}</span>
          </UserStatusContent>
        </UserStatusBottomWrap>
      </Form>
    </ModalFormContainer>
  );
}
